// import './assets/main.css'

import { createApp } from "vue";
import "./style.css";

import App from "./App.vue";
import { clerkPlugin } from "@clerk/vue";
import { createPinia } from "pinia";
import PrimeVue from "primevue/config";

const app = createApp(App);

const pinia = createPinia();
app.use(pinia);

app.use(clerkPlugin, {
  publishableKey: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY,
});

import router from "./router";

app.use(router);

// import VueDiff from "vue-diff";

// import "vue-diff/dist/index.css";

// app.use(VueDiff);

import posthog from "posthog-js";

posthog.init("phc_1dNJEjSlJ5vKKNDA9KCbflyb1O8FS3qlYQgdWLyszFm", {
  api_host: "https://app.posthog.com",
});

// import "highlight.js/styles/stackoverflow-light.min.css";
import hljs from "highlight.js/lib/core";
import json from "highlight.js/lib/languages/json";

import python from "highlight.js/lib/languages/python";
import bash from "highlight.js/lib/languages/bash";
import javascript from "highlight.js/lib/languages/javascript";
import hljsVuePlugin from "@highlightjs/vue-plugin";

// import "highlight.js/styles/atom-one-dark.css";
// import "highlight.js/styles/atom-one-light.css";

hljs.registerLanguage("python", python);
hljs.registerLanguage("json", json);
hljs.registerLanguage("bash", bash);
hljs.registerLanguage("javascript", javascript);
app.use(hljsVuePlugin);

// import FloatingVue from "floating-vue";

// app.use(FloatingVue);

import "floating-vue/dist/style.css";
import Aura from "@primevue/themes/aura";
// import Lara from "@primevue/themes/lara";
// import Nora from "@primevue/themes/nora";
import { definePreset } from "@primevue/themes";

const primeVuePreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: "{teal.50}",
      100: "{teal.100}",
      200: "{teal.200}",
      300: "{teal.300}",
      400: "{teal.400}",
      500: "{teal.500}",
      600: "{teal.600}",
      700: "{teal.700}",
      800: "{teal.800}",
      900: "{teal.900}",
      950: "{teal.950}",
    },
  },

  components: {
    tabs: {
      tab: {
        // background: "{zinc.900}",
        colorScheme: {
          // light: {
          //   root: {
          //     background: "{zinc.100}",
          //   },
          // },
          // dark: {
          //   root: {
          //     background: "{zinc.900}",
          //   },
          // },
        },
      },
      // tablist: {
      //   background: "{slate.950}",
      // },
      tabpanel: {
        // background: "{slate.950}",
        colorScheme: {
          // light: {
          //   root: {
          //     background: "{zinc.100}",
          //   },
          // },
          // dark: {
          //   root: {
          //     background: "{zinc.900}",
          //   },
          // },
        },
      },
      // active: {
      //   background: "{slate.100}",
      // },
    },

    card: {
      colorScheme: {
        dark: {
          root: {
            background: "{zinc.900}",
          },
        },
      },
    },
    // timeline.event.min.height
    timeline: {
      event: {
        minHeight: "2rem",
      },
    },
  },
});

app.use(PrimeVue, {
  theme: {
    preset: primeVuePreset,
    options: {
      prefix: "p",
      darkModeSelector: "system",
      cssLayer: false,
    },
  },
});

import Tooltip from "primevue/tooltip";

app.directive("tooltip", Tooltip);

import ConfirmationService from "primevue/confirmationservice";
app.use(ConfirmationService);

app.mount("#app");
